const reformatItemData = (itemData, relationships, depth=0, firstItem=false) => {
    if (window.is_demo && depth === 0 && firstItem) {
        depth++
        itemData.attributes.name = window.demo_gantt_chart_name
    }
    relationships[itemData.id.toString()] = itemData.relationships
    if (!itemData.hasOwnProperty('items') || Object.keys(itemData.items).length === 0) {
        return itemData
    }
    for (const itemId in itemData.items) {
        itemData.items[itemId] = reformatItemData(itemData.items[itemId], relationships, depth)
    }
    return itemData
}

export const createTreeData = (projectData, itemsData) => {
    let relationships = {}
    let data = {
        id: 'root',
        attributes: {
            name: projectData.attributes.name
        },
        items: {},
        relationships: relationships
    }
    let firstItem = true
    for (const itemId in itemsData) {
        data.items[itemId] = reformatItemData(itemsData[itemId], relationships, 0, firstItem)
        firstItem = false
    }
    return data
}


export function createItemIdArray(itemData, itemId, IdsArray=[]) {

    for (const child in itemData.childrens) {
        if(itemId === itemData.childrens[child].id){
            IdsArray = createIdArray(itemData.childrens[child])
            return IdsArray
        }
        IdsArray = createItemIdArray(itemData.childrens[child], itemId, IdsArray)
    }
    
    return IdsArray
  
}

function createIdArray(item, IdsArray=[]) {

    IdsArray.push(item.id)
    for (const child in item.childrens) {
        IdsArray = createIdArray(item.childrens[child], IdsArray)
    }
    return IdsArray
  
}

export function createCustomIdArray (items, IdsArray=[]) {
    for (const item of Object.values(items)) {
        IdsArray.push(item.id)
    }
    return IdsArray
}

export function formatItemProgress(itemId, name, progressData) {

    const progress = progressData.progress
    const plannedProgress = progressData.planned_progress
    const price = progressData.price
    const plannedPrice = progressData.planned_price

    const item = {
        itemId: itemId,
        name: name,
        progress: progress,
        plannedProgress: plannedProgress,
        price: price,
        plannedPrice: plannedPrice
    }

    return item
}

export function createRelationshipsFilter(relationships) {
    let filters = ['all']
    let levelFilter = ['in', 'level_id']
    let categoryFilter = ['in', 'card_category_id']
    let protocolFilter = ['in', 'protocol_id']
    let zoneFilter = ['in', 'zone_id']
    for (const id in relationships) {
        if (relationships[id].attributes.element_type === 'levels') {
            levelFilter.push(relationships[id].attributes.element_id)
        } else if (relationships[id].attributes.element_type === 'card_categories') {
            categoryFilter.push(relationships[id].attributes.element_id)
        } else if (relationships[id].attributes.element_type === 'protocols') {
            protocolFilter.push(relationships[id].attributes.element_id)
        } else if (relationships[id].attributes.element_type === 'zones') {
            zoneFilter.push(relationships[id].attributes.element_id)
        }
    }
    filters.push(levelFilter)
    filters.push(categoryFilter)
    filters.push(protocolFilter)
    filters.push(zoneFilter)
    return filters
}